import { z } from "zod";
import { RichTextSchema } from "../../RichText";
import { BladeCommonSchema } from "../../../types";
import { ActionSchema } from "../../Actions";
import { MediaSchema } from "../../Media";
const RichTextBladeSideMediaPositionEnum = z.enum(["before", "after"]);
export const RichTextBladeSideMediaSchema = z.object({
    media: MediaSchema,
    position: RichTextBladeSideMediaPositionEnum,
    action: ActionSchema.optional(),
});
export const RichTextBladeSchema = BladeCommonSchema.extend({
    richText: RichTextSchema,
    sideMedia: RichTextBladeSideMediaSchema.optional(),
});
//# sourceMappingURL=index.js.map